// @ts-nocheck 59d03a8d
import PropTypes from 'prop-types';
import React from 'react';
import * as BaseUI from '#packages/baseUI';
import * as util from '#packages/util';
import styles from './sectionControlsButton.scss';

//TYPE WAS GENERATED, remove this line when reviewed
interface Props {
  onClick?: FunctionFixMe;
  tooltip?: string;
  symbol: string;
  isDisabled?: boolean;
}

export default class extends React.Component<Props> {
  static displayName = 'sectionControlsButton';

  static propTypes = {
    onClick: PropTypes.func,
    tooltip: PropTypes.string,
    symbol: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
  };

  onClick = () => {
    if (!this.isDisabled) {
      this.props.onClick();
    }
  };

  render() {
    return (
      <BaseUI.tooltip
        value={this.props.tooltip}
        styleType="small"
        disabled={!this.props.tooltip}
      >
        <div
          onClick={() => {
            this.onClick();
          }}
          onMouseEnter={this.props.onMouseEnter}
          onMouseLeave={this.props.onMouseLeave}
          className={util.cx(styles.sectionControlsButton, {
            [styles.withLabel]: this.props.label,
            [styles.disabled]: this.props.isDisabled,
          })}
        >
          <BaseUI.symbol name={this.props.symbol} className={styles.symbol} />
          <span>{this.props.label}</span>
        </div>
      </BaseUI.tooltip>
    );
  }
}
